import { useEffect } from 'react'

export function Header({ onToggleMenu }: { onToggleMenu: () => void }) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        document.dispatchEvent(new CustomEvent('astro:search'))
        event.preventDefault()
      }
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [])

  return (
    <header className="flex h-14 items-center gap-3 border-b border-neutral-800 bg-gradient-to-b from-ink-1 to-ink-0/60 px-4 backdrop-blur-md">
      <button
        type="button"
        onClick={onToggleMenu}
        className="rounded-lg border border-neutral-800 px-3 py-1.5 text-sm text-neutral-300 transition hover:bg-neutral-900"
      >
        ☰
      </button>
      <div className="font-semibold tracking-wide text-slate-100">AstroTracker</div>
      <div className="ml-auto flex items-center gap-3">
        <span className="rounded-full border border-neutral-800 px-2 py-1 text-xs text-neutral-400">
          LIVE • CACHED
        </span>
      </div>
    </header>
  )
}
